export const lifeBenefits: string[] = [
  'VOLADD_CH',
  'VOLADD_EE',
  'VOLADD_SP',
  'LIFE_CH',
  'LIFE_EE',
  'LIFE_SP',
  'UNLIEC_NY',
  'UNLIEE_NY',
  'UNLIES_NY',
  'UNLIEC_OT',
  'UNLIEE_OT',
  'UNLIES_OT',
];
